import React from "react";
import { useLocation } from "react-router-dom";
import i18n from "../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import Et3PageTitle from "../../../core/et3-page-title/index";
import Et3Margin from "../../../core/et3-ui/ET3Margin";
import getCoreHistoryStore from "../../../stores/core/core-history-store";
import getUserConversationStore from "../../../stores/user-store/conversation-store";
import ConversationForm from "./conversation-form";
import ConversationData from "./conversation-data";
import ET3PageDiv from "../../../core/et3-page-div";

const ConversationsPage = withLiteObserverAndTheme(() => {
  const location = useLocation();
  React.useEffect(() => {
    const checkURL = async () => {
      await getUserConversationStore().checkURL(location);
    };
    getCoreHistoryStore().setPageName(
      "USER_CONVERSATIONS",
      "USER_CONVERSATIONS"
    );
    checkURL();
  }, []);

  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{}}
    >
      <Et3PageTitle
        title={i18n.get("CONVERSATION")}
        subTitle={i18n.get("BETWEEN_TWO_USERS")}
        withRefresh={false}
        withHelper={false}
        onPress={() => {}}
      />
      <ConversationForm />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <ConversationData />
    </ET3PageDiv>
  );
});
export default ConversationsPage;
